import React, { useEffect, useState } from 'react';
import './ThemeToggle.css';
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";

function getInitialTheme() {
    const saved = localStorage.getItem('theme');
    if (saved === 'light' || saved === 'dark') return saved;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export default function ThemeToggle() {
    const { t } = useTranslation();
    const [theme, setTheme] = useState(getInitialTheme);

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('theme', theme);
    }, [theme]);

    const toggle = () => setTheme(prev => (prev === 'dark' ? 'light' : 'dark'));

    return (
        <li className="theme-toggle-item">
            <button
                type="button"
                className="theme-toggle-btn"
                onClick={toggle}
                title={theme === 'dark' ? t("Switch to light mode") : t("Switch to dark mode")}
                aria-label="Toggle dark mode"
            >
                <FontAwesomeIcon icon={theme === 'dark' ? faSun : faMoon} />
            </button>
        </li>
    );
}
